import { supabase } from "./supabaseClient";

export const getActiveSurveyBySlug = async (slug) => {
  if (!slug) {
    throw new Error("Missing survey slug.");
  }

  const { data, error } = await supabase
    .rpc("get_active_survey_by_slug", { p_slug: slug })
    .single();

  if (error) {
    throw new Error(error.message || "Unable to load survey.");
  }

  if (!data) {
    throw new Error("Survey not found.");
  }

  return data;
};

export const submitSurveyResponse = async ({
  supabaseUrl,
  surveyVersionId,
  answers,
  meta,
  turnstileToken,
}) => {
  if (!supabaseUrl) {
    throw new Error("Supabase URL is not configured.");
  }

  const anonKey =
    process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY || "";

  const res = await fetch(`${supabaseUrl}/functions/v1/ingest-survey`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(anonKey
        ? {
            apikey: anonKey,
            Authorization: `Bearer ${anonKey}`,
          }
        : {}),
    },
    body: JSON.stringify({
      survey_version_id: surveyVersionId,
      answers,
      meta,
      turnstile_token: turnstileToken || undefined,
    }),
  });

  const payload = await res.json().catch(() => ({}));

  if (!res.ok || payload.ok !== true) {
    const message = payload.error || "Submission failed.";
    throw new Error(message);
  }

  return payload;
};
